export default {
  warning: {
    '30': '#f1b105',
  },
};
